import { motion } from 'framer-motion';
import Image from 'next/image';
// import { useRouter } from 'next/navigation';
// import { useCallback } from 'react';

const animation = {
  initial: { opacity: 0, y: 20 },
  animate: {
    opacity: 1,
    y: 0,
  },
};

export const ArtistLogo = ({
  imageUrl,
  logoWidthPx,
}: {
  className?: string;
  imageUrl: string;
  logoWidthPx: number;
}) => {
  // const router = useRouter();

  //   const handleClick = useCallback(() => {
  //     if (router.pathname === '/') {
  //       return window.scrollTo({ top: 0, behavior: 'smooth' });
  //     }
  //     router.push('/');
  //   }, [router]);

  if (!imageUrl) {
    return (
      <div className="mx-auto flex h-[154px] w-[280px] items-center justify-center rounded-xl bg-gray-600 text-center opacity-50">
        Beispiel Logo
      </div>
    );
  }

  return (
    <motion.div initial={animation.initial} animate={animation.animate}>
      <Image
        key={logoWidthPx}
        src={imageUrl}
        className="mx-auto"
        alt="Logo"
        width={logoWidthPx}
        height={logoWidthPx / 2}
      />
    </motion.div>
  );
};
